import { render, staticRenderFns } from "./followUpDetail.vue?vue&type=template&id=f67356aa&scoped=true&"
import script from "./followUpDetail.vue?vue&type=script&lang=js&"
export * from "./followUpDetail.vue?vue&type=script&lang=js&"
import style0 from "./followUpDetail.vue?vue&type=style&index=0&id=f67356aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67356aa",
  null
  
)

export default component.exports